<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ueAK1i/tc-custom/9781473863590.jpg?1703819678110" alt="This image is the cover for the book Fall of Burma, 1941–1943, Despatches from the Front"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fall of Burma, 1941–1943, Despatches from the Front
      </h1>
      <p class="bookDescription body article font2">
        <p>Despatches in this volume include that on operations in Burma between 15 December 1941 and 20 May 1942 by General Wavell; Operations in Eastern Theatre, based on India, March 1942 to 31 December 1942 by Field-Marshall Wavell; Operations in the Indo-Burma Theatre 21 June to 15 November 1942 by Field-Marshall Auchinleck; and Operations in the India Command 1 January to 20 June 1943 by Field-Marshall Wavell.This unique collection of original documents will prove to be an invaluable resource for historians, students and all those interested in what was one of the most significant periods in British military history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Grehan, Martin Mace
      </h2>
      
      <p class="authorDescription body article">JOHN GREHAN has written, edited or contributed to more than 300 books and magazine articles covering a wide span of military history from the Iron Age to the recent conflict in Afghanistan. John has also appeared on local and national radio and television to advise on military history topics. He was employed as the Assistant Editor of Britain at War Magazine from its inception until 2014. John now devotes his time to writing and editing books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?669f1f0d